@if (relativeUrl()) {
  <a
    [ngClass]="className"
    [routerLink]="relativeUrl()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-haspopup]="ariaHasPopup() ? 'dialog' : null"
    [attr.role]="role()"
    [attr.aria-live]="ariaLive()"
    [type]="type()"
  >
    <ng-template [ngTemplateOutlet]="content"> </ng-template>
  </a>
} @else if (url()) {
  <a [href]="url()" [attr.target]="isNewTab() ? '_blank' : '_self'" [ngClass]="className">
    <ng-template [ngTemplateOutlet]="content"> </ng-template>
  </a>
} @else {
  <button
    [ngClass]="className"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-haspopup]="ariaHasPopup() ? 'dialog' : null"
    [attr.role]="role()"
    [attr.aria-live]="ariaLive()"
    [type]="type()"
    (click)="clicked.emit($event)"
  >
    <ng-template [ngTemplateOutlet]="content"> </ng-template>
  </button>
}
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
